import AOA from './AOA';
import BIF from './BIF';
import BWP from './BWP';
import CDF from './CDF';
import CVE from './CVE';
import DJF from './DJF';
import DZD from './DZD';
import EGP from './EGP';
import ERN from './ERN';
import ETB from './ETB';
import GHS from './GHS';
import GMD from './GMD';
import GNF from './GNF';
import KES from './KES';
import KMF from './KMF';
import LRD from './LRD';
import LSL from './LSL';
import LYD from './LYD';
import MAD from './MAD';
import MGA from './MGA';
import MNT from './MNT';
import MRU from './MRU';
import MUR from './MUR';
import MWK from './MWK';
import MZN from './MZN';
import NAD from './NAD';
import NGN from './NGN';
import RWF from './RWF';
import SCR from './SCR';
import SDG from './SDG';
import SHP from './SHP';
import SLL from './SLL';
import SOS from './SOS';
import SSP from './SSP';
import STN from './STN';
import SZL from './SZL';
import TZS from './TZS';
import XAF from './XAF';
import XOF from './XOF';
import ZAR from './ZAR';
import ZMW from './ZMW';
import ZWL from './ZWL';

export const AFRICA_CURRENCIES = {
    [AOA.codeNumeric]: AOA,
    [BIF.codeNumeric]: BIF,
    [BWP.codeNumeric]: BWP,
    [CDF.codeNumeric]: CDF,
    [CVE.codeNumeric]: CVE,
    [DJF.codeNumeric]: DJF,
    [DZD.codeNumeric]: DZD,
    [EGP.codeNumeric]: EGP,
    [ERN.codeNumeric]: ERN,
    [ETB.codeNumeric]: ETB,
    [GHS.codeNumeric]: GHS,
    [GMD.codeNumeric]: GMD,
    [GNF.codeNumeric]: GNF,
    [KES.codeNumeric]: KES,
    [KMF.codeNumeric]: KMF,
    [LRD.codeNumeric]: LRD,
    [LSL.codeNumeric]: LSL,
    [LYD.codeNumeric]: LYD,
    [MAD.codeNumeric]: MAD,
    [MGA.codeNumeric]: MGA,
    [MNT.codeNumeric]: MNT,
    [MRU.codeNumeric]: MRU,
    [MUR.codeNumeric]: MUR,
    [MWK.codeNumeric]: MWK,
    [MZN.codeNumeric]: MZN,
    [NAD.codeNumeric]: NAD,
    [NGN.codeNumeric]: NGN,
    [RWF.codeNumeric]: RWF,
    [SCR.codeNumeric]: SCR,
    [SDG.codeNumeric]: SDG,
    [SHP.codeNumeric]: SHP,
    [SLL.codeNumeric]: SLL,
    [SOS.codeNumeric]: SOS,
    [SSP.codeNumeric]: SSP,
    [STN.codeNumeric]: STN,
    [SZL.codeNumeric]: SZL,
    [TZS.codeNumeric]: TZS,
    [XAF.codeNumeric]: XAF,
    [XOF.codeNumeric]: XOF,
    [ZAR.codeNumeric]: ZAR,
    [ZMW.codeNumeric]: ZMW,
    [ZWL.codeNumeric]: ZWL
};
